import { z } from "zod";

export const SourceSchema = z.object({
  id: z.string().uuid(),
  jurisdictionId: z.string().uuid(),
  url: z.string().url(),
  adapterType: z.string().min(1),
  schedule: z.string().optional().nullable(),
  lastOkAt: z.string().datetime().nullable(),
  lastError: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Source = z.infer<typeof SourceSchema>;
